export abstract class AbstractStorage<S = Record<string, unknown>> {
    public abstract store: S;

    public abstract getItem(name: keyof S): string | Promise<string | null> | null;
    public abstract setItem(name: keyof S, value: string): void | Promise<void>;
    public abstract removeItem(name: keyof S): void | Promise<void>;

    public abstract hydrate(data: Record<string, any>): void;
}
